module.exports = __webpack_public_path__ + "img/0-129.94b976d2.jpg";